/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		11: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-week","1":"route-editor","2":"route-wizard","3":"route-resetexec","4":"route-reset","5":"route-register","6":"route-login","7":"route-home","8":"route-print","9":"route-profile","10":"route-dash"}[chunkId]||chunkId) + ".chunk." + {"0":"f1e26","1":"bf76a","2":"1a7f0","3":"5192f","4":"30fe1","5":"e5d90","6":"d0905","7":"575f2","8":"2aec9","9":"4b720","10":"4d761"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/Umn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"marginLeftAuto":"marginLeftAuto__3rm0W","Container":"Container__3o5Om","PrintContainer":"PrintContainer__1Nqp6","Illustration":"Illustration__20sQQ","Hr":"Hr__jssIq","Spacer":"Spacer__2Fg9N","SpacerSmall":"SpacerSmall__38Dgc","SpacerMedium":"SpacerMedium__3UxK5","Table":"Table__1XXHE","Caption":"Caption__16rlh","Td":"Td__3PWAC","Th":"Th__prM-O","hasActions":"hasActions__3TDNg","DelButton":"DelButton__IseM2","TextPositive":"TextPositive__1FyiM","TextNegative":"TextNegative__1_A3j","Form":"Form__2T-FZ","FormWithPadding":"FormWithPadding__qJQsa","FormGroup":"FormGroup__1WeE3","input":"input__3pGlj","FormGroupHor":"FormGroupHor__27msZ","FormLabelHor":"FormLabelHor__2OR0h","FormControl":"FormControl__m-Jrk","FormLabel":"FormLabel__2k9KE","CheckboxGroup":"CheckboxGroup__21DR7","label":"label__3ohD6","Checkbox":"Checkbox__2qNAj","CheckboxRadio":"CheckboxRadio__1-czK","RadioButtonGroup":"RadioButtonGroup__1yCWA","RadioButton":"RadioButton__1yX7L","muted":"muted__2JHbM","content":"content__2zY7d","listCaption":"listCaption__1cmPy","printWeight":"printWeight__23n8H","backdrop":"backdrop__15Shr","modal":"modal__1u654","modalContent":"modalContent__XvZTG","buttonGroup":"buttonGroup__2tgYs","buttonGroupHorizontal":"buttonGroupHorizontal__1irdT","buttonGroupHorizontal2":"buttonGroupHorizontal2__qJerj","min70":"min70__1dZGA","pad10":"pad10__Gf6bH","errorMessage":"errorMessage__2j2-w","spinner":"spinner__2MM9O","rotation":"rotation__2uoHs","listCaption1":"listCaption1__2skzr","listCaption2":"listCaption2__382N0","list":"list__2ZPQf","listPad":"listPad__2KTIp","listWithoutBorder":"listWithoutBorder__zq-c4","listItem":"listItem__2BTuI","condensedListItem":"condensedListItem__233W7","marginLeftAutoPlus":"marginLeftAutoPlus__1nUap","listHeader":"listHeader__2ETg-","listTitle":"listTitle__1F27c","listTitleSmall":"listTitleSmall__3blf7","listTitleNumber":"listTitleNumber__2NfED","weekButton":"weekButton__33Mdi","bold":"bold__3gI3C","imageGroup":"imageGroup__1f6B8","image":"image__LsSjq","noteBox":"noteBox__3_W43","exerciseDetailsHeader":"exerciseDetailsHeader__2cHlz","exerciseDetailsInput":"exerciseDetailsInput__2JDhc","exerciseDetails":"exerciseDetails__28uDF","fill":"fill__22u6X","scroll":"scroll__2x0gp","inner":"inner__3Xe1c","buttonWizard":"buttonWizard__1snab","women":"women__ncTob","buttonWizardSmall":"buttonWizardSmall__nIhOT","buttonWizardVerySmall":"buttonWizardVerySmall__1JaHx","buttonDisabled":"buttonDisabled__oQy4X","Header":"Header__2OU5p","Nav":"Nav__1eF2p","NavItem":"NavItem__30J5Y","active":"active__2kmrA","NavItemIcon":"NavItemIcon__3UYqY","NavItemLabel":"NavItemLabel__oQ7uZ"};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("pwNi");


/***/ }),

/***/ "3yWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function(require) {
				cb(__webpack_require__("kskJ"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (load) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);
		var done = function done(child) {
			_this.setState({ child: child && child.default || child });
		};
		var r = load(done);
		if (r && r.then) r.then(done);
	}
	Async.prototype = new _preact.Component();
	Async.prototype.constructor = Async;
	Async.prototype.render = function (props, state) {
		return (0, _preact.h)(state.child, props);
	};
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "8Jtg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60561026a9099d191f1ab737d1e81d6e.svg";

/***/ }),

/***/ "8lMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function(require) {
				cb(__webpack_require__("VTE3"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "ARLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = register;
/* harmony export (immutable) */ __webpack_exports__["l"] = login;
/* harmony export (immutable) */ __webpack_exports__["j"] = pwreset;
/* harmony export (immutable) */ __webpack_exports__["i"] = resetExec;
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* unused harmony export getAccessToken */
/* unused harmony export getExpiry */
/* harmony export (immutable) */ __webpack_exports__["g"] = setLs;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLs;
/* harmony export (immutable) */ __webpack_exports__["d"] = syncLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateApiData;
/* unused harmony export setAccessToken */
/* unused harmony export setExpiry */
/* harmony export (immutable) */ __webpack_exports__["b"] = getGender;
/* harmony export (immutable) */ __webpack_exports__["c"] = setGender;
/* harmony export (immutable) */ __webpack_exports__["a"] = isLoggedIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookiestore__ = __webpack_require__("f6mu");



var ACCESS_TOKEN_KEY = "access_token";
var EXPIRES_IN = "expires_in";
var CLIENT_ID = 1;
var CLIENT_SECRET = "pie8Eu2JmeanoJe6ab2eiCaekeiGooD6";
var urllogin = "https://shopify.ilpt.de/api/access_token?shop=ilptbook.myshopify.com";
var urlregister = "https://shopify.ilpt.de/api/apps/?shop=ilptbook.myshopify.com";
var urlfetch = "https://shopify.ilpt.de/api/apps/me?shop=ilptbook.myshopify.com";
var urlreset = "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com&product=mwp-ebook";
var urlresetexec = "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com";

// https://auth0.com/blog/preact-authentication-tutorial/
// https://preact.gitbooks.io/react-book/content/flux/auth.html

var isSupported = function isSupported() {
  try {
    var key = "__some_random_key_you_are_not_going_to_use__";
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    console.log("ls");
    return localStorage;
  } catch (e) {
    console.log("ls issue");
  }
  try {
    var key2 = "__some_other_random_key_you_are_not_going_to_use__";
    sessionStorage.setItem(key2, key2);
    sessionStorage.removeItem(key2);
    console.log("ss");
    return sessionStorage;
  } catch (e) {
    console.log("ss issue, going for cookie");
    return __WEBPACK_IMPORTED_MODULE_1__cookiestore__["a" /* default */];
    // cookieStorage
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie/Simple_document.cookie_framework
  }
};

var prefix = isSupported();

function register(email, password, token, cb, that) {
  var res = false;

  var obj = {
    email: email,
    password: password,
    token: token
  };

  // console.log("obj reg", obj);

  var init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  fetch(urlregister, init).then(function (response) {
    // console.log(response);
    if (response.ok) {
      // console.log('ok');
      return response.json();
    }
    // throw new TypeError("Oops, we haven't got JSON!");
    console.log("registration not successful");
    console.log(response.status); // 400 for wrong credentials
    res = true;
    cb(res, that);
  }).then(function (json) {
    if (json) {
      console.log("json success", json);
      res = false;
      cb(res, that);
    }
  }).catch(function (err) {
    console.log("err", err);
    res = true;
    cb(res, that);
  });

  return res;
}

function login(username, password, cb, that, gender) {
  var res = false;

  var obj = {
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: "password",
    username: username,
    password: password
  };

  var init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  function cb2(res) {
    console.log("cb2 issue? ", res);
    console.log("routing to dash ...");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact_router__["route"])("/" + gender + "/dash");
  }

  fetch(urllogin, init).then(function (response) {
    // console.log(response);
    if (response.ok) {
      // console.log('ok');
      return response.json();
    }
    // throw new TypeError("Oops, we haven't got JSON!");
    console.log("login not successful");
    console.log(response.status); // 400 for wrong credentials
    res = true;
    cb(res, that);
  }).then(function (json) {
    if (json) {
      // successful login
      // console.log('json', json);
      setAccessToken(json.access_token);
      setExpiry(json.expires_in);
      syncLocalStorage(cb2);
    }
  }).catch(function (err) {
    console.log("err", err); // catching when no internet connection
    res = true;
    cb(res, that);
  });
  // console.log('login initiated');
  return;
}

function pwreset(email, cb, that) {
  var res = false;

  var obj = {
    email: email
  };

  var init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  fetch(urlreset, init).then(function (response) {
    // console.log(response);
    if (response.ok) {
      console.log("reset initiiated");
      cb(res, that);
      return;
    }
    // throw new TypeError("Oops, we haven't got JSON!");
    console.log("reset not successful");
    res = true;
    cb(res, that);
  }).catch(function (err) {
    console.log("err", err);
  });

  return;
}

function resetExec(password, token, cb, that) {
  var res = false; // error?

  var obj = {
    password: password,
    password_reset_token: token
  };

  var init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  fetch(urlresetexec, init).then(function (response) {
    // console.log(response);
    if (response.ok) {
      console.log("resetexec initiiated");
      cb(res, that);
      return;
    }
    // throw new TypeError("Oops, we haven't got JSON!");
    console.log("resetexec not successful");
    console.log("response.status", response.status);
    console.log("response.statusText ", response.statusText);
    res = true;
    cb(res, that);
  }).catch(function (err) {
    console.log("err", err);
  });

  return;
}

function logout(gender) {
  clearAccessToken();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact_router__["route"])("/" + gender);
}

function getAccessToken() {
  if (typeof window !== "undefined") {
    return prefix.getItem(ACCESS_TOKEN_KEY);
  }
}

function getExpiry() {
  if (typeof window !== "undefined") {
    return prefix.getItem(EXPIRES_IN);
  }
}

function setLs(item, data) {
  if (typeof window !== "undefined") {
    prefix.setItem(item, data);
    console.log("ls set");
    return;
  }
}

function getLs(item) {
  // console.log("pref1", prefix);
  if (typeof window !== "undefined") {
    // console.log("pref2", prefix);
    var res = prefix.getItem(item);
    return res;
  }
}

function syncLocalStorage(cb) {
  var bearer = "Bearer " + getAccessToken();
  var init = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer
    }
  };

  fetch(urlfetch, init).then(function (response) {
    if (response.ok) {
      // console.log("response ok for GET");
      return response.json();
    }
    // console.log("data pull not successful");
    // console.log(response.status);
    // wrong token means 401
    if (response.status === 401) cb(401);else {
      cb(true);
    }
  }).then(function (jsonraw) {
    if (jsonraw) {
      // console.log('json?', jsonraw);
      var json = JSON.parse(jsonraw.payload);
      // console.log('payload', json);
      var getTimeLocalStorage = function getTimeLocalStorage() {
        return prefix.getItem("update_state");
      };

      var timeLocalStorage = getTimeLocalStorage();

      var timeFromAPI = json.update_state;
      // console.log("times", timeLocalStorage, timeFromAPI);

      if (timeLocalStorage > timeFromAPI) {
        // console.log("ls is fresh");
        updateApiData(cb);
      } else if (timeLocalStorage === timeFromAPI) {
        // console.log("both fresh. NoOP");
        cb(false);
      } else {
        // console.log("api is fresher");
        if (json.state && json.update_state) {
          prefix.setItem("state", json.state);

          prefix.setItem("update_state", json.update_state);

          // console.log("ls refreshed");
          cb(false);
        } else {
          // console.log("issue with API data. LS update not successful");
          cb(true);
        }
      }
    }
  }).catch(function (err) {
    console.log("err", err);
    // typically no internet connection
    cb(true);
  });
}

function updateApiData(cb) {
  var res = false; // no error
  var bearer = "Bearer " + getAccessToken();

  var getLsState = function getLsState() {
    return prefix.getItem("state");
  };

  var lsState = getLsState();

  var getLsUpdate = function getLsUpdate() {
    return prefix.getItem("update_state");
  };

  var lsUpdate = getLsUpdate();

  // console.log("updateAPI lsState", lsState);
  // console.log("updateAPI lsUpdate", lsUpdate);

  if (!lsState || !lsUpdate) {
    console.log("LS Data not available");
    res = true;
    cb(res);
    return;
  }

  var payload = JSON.stringify({ state: lsState, update_state: lsUpdate });

  var obj = {
    payload: payload
  };

  var init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer
    },
    body: JSON.stringify(obj)
  };

  fetch(urlfetch, init).then(function (response) {
    // console.log(response);
    if (response.ok) {
      // console.log("response ok for PUT");
      return response.json();
    }
    // throw new TypeError("Oops, we haven't got JSON!");
    // console.log("data put not successful");
    res = true;
    cb(res);
  }).then(function (json) {
    // console.log("through");
    if (json) {
      // console.log("json???", json);
      // console.log("API update done. before nested callback");
      cb(res);
    }
  }).catch(function (err) {
    // console.log("err", err);
    res = true;
    cb(res);
  });
}

function clearAccessToken() {
  if (typeof window !== "undefined") {
    prefix.removeItem(ACCESS_TOKEN_KEY);
  }
}

function setAccessToken(token) {
  if (typeof window !== "undefined") {
    prefix.setItem(ACCESS_TOKEN_KEY, token);
  }
}

function setExpiry(token) {
  if (typeof window !== "undefined") {
    prefix.setItem(EXPIRES_IN, token);
  }
}

function getGender() {
  if (typeof window !== "undefined") {
    var gen = prefix.getItem("gender");
    return gen ? gen : "women";
  }
  console.log("bust");
}

function setGender(gender) {
  if (typeof window !== "undefined") {
    // console.log("pre gender", prefix);

    prefix.setItem("gender", gender);
  }
}

function isLoggedIn() {
  var bearerToken = getAccessToken();
  var expiry = getExpiry();
  return !!bearerToken && !isTokenExpired(expiry);
}

function getTokenExpirationDate(encodedToken) {
  var exp = encodedToken;
  if (!exp) {
    return null;
  }

  var date = new Date();
  date.setUTCSeconds(exp);

  return date;
}

function isTokenExpired(token) {
  var expirationDate = getTokenExpirationDate(token);
  var date = new Date();
  //console.log('expiration', expirationDate);
  //console.log('real date', date);
  return expirationDate < date;
}

/***/ }),

/***/ "BFZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function(require) {
				cb(__webpack_require__("DERA"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "C77t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function(require) {
				cb(__webpack_require__("UCDc"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "E1C8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function(require) {
				cb(__webpack_require__("bDEW"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "EbM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__("EbM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app__ = __webpack_require__("qLaj");



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1__components_app__["a" /* default */]);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "NQkC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function(require) {
				cb(__webpack_require__("2+Sr"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "RrDT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da0318ff47115bf85e8673ef7d580c3f.svg";

/***/ }),

/***/ "eOt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function(require) {
				cb(__webpack_require__("9PGE"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "f6mu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var inMemoryStorage = {};

function getItem(sKey) {
  return inMemoryStorage[sKey] || null;
}

function setItem(sKey, sValue) {
  inMemoryStorage[sKey] = sValue;
}

function removeItem(sKey) {
  delete inMemoryStorage[sKey];
}

function hasItem(sKey) {
  return false;
  // placeholder
}

function keys() {
  return Object.keys(inMemoryStorage)[n] || null;
}

/* harmony default export */ __webpack_exports__["a"] = ({ getItem: getItem, setItem: setItem, removeItem: removeItem, hasItem: hasItem, keys: keys });

/***/ }),

/***/ "gNuw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function(require) {
				cb(__webpack_require__("RdKF"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "iHG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function(require) {
				cb(__webpack_require__("eVxc"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "ipAq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e619e187fbfc87c19c71ab2f3aa231e1.svg";

/***/ }),

/***/ "kiFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function(require) {
				cb(__webpack_require__("4nDD"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "n6iU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function(require) {
				cb(__webpack_require__("xJ+h"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if ('serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register('/sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default || m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qLaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__("sIAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authstore__ = __webpack_require__("ARLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_home__ = __webpack_require__("E1C8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_login__ = __webpack_require__("n6iU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_register__ = __webpack_require__("C77t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_reset__ = __webpack_require__("kiFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_resetexec__ = __webpack_require__("iHG/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_profile__ = __webpack_require__("gNuw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes_wizard__ = __webpack_require__("3yWK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_editor__ = __webpack_require__("8lMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routes_dash__ = __webpack_require__("eOt4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__routes_week__ = __webpack_require__("BFZB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes_print__ = __webpack_require__("NQkC");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















// import Home from 'async!./home';
// import Profile from 'async!./profile';

var AuthenticatedRoute = function (_Component) {
  _inherits(AuthenticatedRoute, _Component);

  function AuthenticatedRoute() {
    _classCallCheck(this, AuthenticatedRoute);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AuthenticatedRoute.prototype.componentWillMount = function componentWillMount() {
    var check = this.props.check;

    this.allowed = check();
    // console.log("gender auth", this.props.gender);
    if (!this.allowed) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact_router__["route"])("/" + this.props.gender);
  };

  AuthenticatedRoute.prototype.render = function render(_ref) {
    var check = _ref.check,
        Route = _ref.route,
        props = _objectWithoutProperties(_ref, ["check", "route"]);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      null,
      this.allowed && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Route, props)
    );
  };

  return AuthenticatedRoute;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__routes_home__["a" /* default */], { path: "/", "default": true, gender: "women" });

var _ref5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__routes_login__["a" /* default */], { path: "/men", gender: "men" });

var _ref6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__routes_login__["a" /* default */], { path: "/women", gender: "women" });

var _ref7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__routes_register__["a" /* default */], { path: "/men/register", token: "", email: "", gender: "men" });

var _ref8 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__routes_register__["a" /* default */], { path: "/men/register/:token/:email", gender: "men" });

var _ref9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__routes_register__["a" /* default */], { path: "/women/register", token: "", email: "", gender: "women" });

var _ref10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__routes_register__["a" /* default */], { path: "/women/register/:token/:email", gender: "women" });

var _ref11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__routes_reset__["a" /* default */], { path: "/men/reset", gender: "men" });

var _ref12 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__routes_reset__["a" /* default */], { path: "/women/reset", gender: "women" });

var _ref13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__routes_resetexec__["a" /* default */], { path: "/men/password-reset", token: "", gender: "men" });

var _ref14 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__routes_resetexec__["a" /* default */], { path: "/men/password-reset/:token", gender: "men" });

var _ref15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__routes_resetexec__["a" /* default */], { path: "/women/password-reset", token: "", gender: "women" });

var _ref16 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__routes_resetexec__["a" /* default */], { path: "/women/password-reset/:token", gender: "women" });

var _ref17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/men/wizard/:step",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_10__routes_wizard__["a" /* default */],
  gender: "men"
});

var _ref18 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/men/editor/:workout",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_11__routes_editor__["a" /* default */],
  gender: "men"
});

var _ref19 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, { path: "/men/dash/", check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */], route: __WEBPACK_IMPORTED_MODULE_12__routes_dash__["a" /* default */], gender: "men" });

var _ref20 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/men/week/",
  week: "",
  workout: "",
  exercise: "",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "men"
});

var _ref21 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/men/week/:week",
  workout: "",
  exercise: "",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "men"
});

var _ref22 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/men/week/:week/:workout",
  exercise: "",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "men"
});

var _ref23 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/men/week/:week/:workout/:exercise",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "men"
});

var _ref24 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, { path: "/men/print", check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */], route: __WEBPACK_IMPORTED_MODULE_14__routes_print__["a" /* default */], gender: "men" });

var _ref25 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/women/wizard/:step",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_10__routes_wizard__["a" /* default */],
  gender: "women"
});

var _ref26 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/women/editor/:workout",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_11__routes_editor__["a" /* default */],
  gender: "women"
});

var _ref27 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, { path: "/women/dash/", check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */], route: __WEBPACK_IMPORTED_MODULE_12__routes_dash__["a" /* default */], gender: "women" });

var _ref28 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/women/week/",
  week: "",
  workout: "",
  exercise: "",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "women"
});

var _ref29 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/women/week/:week",
  workout: "",
  exercise: "",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "women"
});

var _ref30 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/women/week/:week/:workout",
  exercise: "",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "women"
});

var _ref31 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, {
  path: "/women/week/:week/:workout/:exercise",
  check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */],
  route: __WEBPACK_IMPORTED_MODULE_13__routes_week__["a" /* default */],
  gender: "women"
});

var _ref32 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AuthenticatedRoute, { path: "/women/print", check: __WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */], route: __WEBPACK_IMPORTED_MODULE_14__routes_print__["a" /* default */], gender: "women" });

var _ref33 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__routes_profile__["a" /* default */], { path: "/profile/", user: "me" });

var _ref34 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9__routes_profile__["a" /* default */], { path: "/profile/:user" });

var App = function (_Component2) {
  _inherits(App, _Component2);

  function App() {
    var _temp, _this2, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = { userLoggedIn: false, showHeader: true }, _this2.handleRoute = function (e) {
      _this2.currentUrl = e.url;
      var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */])();
      var gender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["b" /* getGender */])();

      // console.log("e", e);
      // console.log("url", e.url);
      if (e.url.includes("women")) gender = "women";else if (e.url.includes("men")) gender = "men";

      _this2.setState({ userLoggedIn: status }); // required for header logged in status
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["c" /* setGender */])(gender);
      _this2.setState({ gender: gender });

      if (e.url === "/" || e.url === "/women" || e.url === "/men" || e.url === "/women/" || e.url === "/men/") {
        // console.log("!! home route detected (in handle route)");
        if (status) {
          // console.log("!! already logged in");
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact_router__["route"])("/" + gender + "/dash");
        }
      }

      if (e.url === "/" || e.url === "/women" || e.url === "/men" || e.url === "/women/" || e.url === "/men/" || e.url.indexOf("/women/re") >= 0 || e.url.indexOf("/men/re") >= 0 || e.url.indexOf("/women/pa") >= 0 || e.url.indexOf("/men/pa") >= 0) {
        _this2.setState({ showHeader: false });
      } else {
        _this2.setState({ showHeader: true });
      }

      // console.log("running route update in handleRoute");
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */


  App.prototype.componentWillMount = function componentWillMount() {
    var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["a" /* isLoggedIn */])();
    var gender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["b" /* getGender */])();

    this.setState({ userLoggedIn: status }); // required for header logged in status
    this.setState({ gender: gender }); // required for header gender CSS
    if (status) {
      // if logged in locally, run sync
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["d" /* syncLocalStorage */])(function (e) {
        // console.log("data synced: ", e);
        if (e === 401) {
          // wrong credentials
          // console.log("logging out locally because of 401");
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["e" /* logout */])(gender);
        }
      });
    }
  };

  App.prototype.componentDidMount = function componentDidMount() {
    var notify = true;

    if (!!window.Notification) {
      console.log("Notification API supported");
    } else {
      notify = false;
    }

    if (notify === true) {
      console.log("Notification.permission", Notification.permission);
      if (Notification.permission == "default") {
        Notification.requestPermission(function (result) {
          console.log("Notification request", result);
        });
      }
    }
  };

  // https://github.com/developit/preact-router

  App.prototype.render = function render(_ref2, _ref3) {
    var userLoggedIn = _ref3.userLoggedIn,
        gender = _ref3.gender,
        showHeader = _ref3.showHeader;

    _objectDestructuringEmpty(_ref2);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      _extends({ id: "app" }, gender === "women" && { class: "women" }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__header__["a" /* default */], { check: userLoggedIn, gender: gender, showHeader: showHeader }),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_1_preact_router__["Router"],
        { onChange: this.handleRoute },
        _ref4,
        _ref5,
        _ref6,
        _ref7,
        _ref8,
        _ref9,
        _ref10,
        _ref11,
        _ref12,
        _ref13,
        _ref14,
        _ref15,
        _ref16,
        _ref17,
        _ref18,
        _ref19,
        _ref20,
        _ref21,
        _ref22,
        _ref23,
        _ref24,
        _ref25,
        _ref26,
        _ref27,
        _ref28,
        _ref29,
        _ref30,
        _ref31,
        _ref32,
        _ref33,
        _ref34
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "sIAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("/Umn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authstore__ = __webpack_require__("ARLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_svg_header_dashboard_svg__ = __webpack_require__("8Jtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_svg_header_dashboard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_svg_header_dashboard_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_svg_header_wizard_svg__ = __webpack_require__("RrDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_svg_header_wizard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_svg_header_wizard_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_svg_header_logout_svg__ = __webpack_require__("ipAq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_svg_header_logout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_svg_header_logout_svg__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLogoutClick = function (e) {
      e.preventDefault(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authstore__["e" /* logout */])(_this.props.gender);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Header.prototype.render = function render(_ref) {
    var check = _ref.check,
        gender = _ref.gender,
        showHeader = _ref.showHeader;

    if (showHeader) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "header",
        {
          "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.Header + " " + (gender === "women" ? __WEBPACK_IMPORTED_MODULE_2__style___default.a.women : null)
        },
        check ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "nav",
          { "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.Nav },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
            {
              "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItem,
              activeClassName: __WEBPACK_IMPORTED_MODULE_2__style___default.a.active,
              href: "/" + gender + "/dash"
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: __WEBPACK_IMPORTED_MODULE_4_assets_svg_header_dashboard_svg___default.a, "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemIcon }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "span",
              { "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemLabel },
              "Dashboard"
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
            {
              "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItem,
              activeClassName: __WEBPACK_IMPORTED_MODULE_2__style___default.a.active,
              href: "/" + gender + "/wizard/1"
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: __WEBPACK_IMPORTED_MODULE_5_assets_svg_header_wizard_svg___default.a, "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemIcon }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "span",
              { "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemLabel },
              "Neuer Plan"
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
            {
              "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItem,
              activeClassName: __WEBPACK_IMPORTED_MODULE_2__style___default.a.active,
              href: "/" + gender,
              onClick: this.handleLogoutClick
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: __WEBPACK_IMPORTED_MODULE_6_assets_svg_header_logout_svg___default.a, "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemIcon }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "span",
              { "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemLabel },
              "Logout"
            )
          )
        ) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "nav",
          { "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.Nav },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
            {
              "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItem,
              activeClassName: __WEBPACK_IMPORTED_MODULE_2__style___default.a.active,
              href: "/" + gender + "/"
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("img", { src: __WEBPACK_IMPORTED_MODULE_4_assets_svg_header_dashboard_svg___default.a, "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemIcon }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "span",
              { "class": __WEBPACK_IMPORTED_MODULE_2__style___default.a.NavItemLabel },
              "Home"
            )
          )
        )
      );
    }
  };

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.a65cc.js